const MILLS_IN_SECOND = 1000
export const MILLS_IN_MINUTE = MILLS_IN_SECOND * 60
const MILLS_IN_HOUR = MILLS_IN_MINUTE * 60

export function timeToMills(time: string): number { // hh:mm:ss.xx -> mills
    if (!time) {
        return 0;
    }

    const [hours, minutes, rest] = time.split(':');
    const [seconds, hundredsOfSeconds] = rest.split('.');
    return +hours * MILLS_IN_HOUR + +minutes * MILLS_IN_MINUTE + +seconds * MILLS_IN_SECOND + +hundredsOfSeconds * 10;
}

export function getCurrentTimeMills(): number {
    const now = new Date();
    return now.getHours() * MILLS_IN_HOUR +
        now.getMinutes() * MILLS_IN_MINUTE +
        now.getSeconds() * MILLS_IN_SECOND +
        now.getMilliseconds();
}